<template>
<div class="address_container">
 <div class="header_container">
  <h3>{{ $t('editAddAddress') }}</h3>
 </div>
 <div class='address_body_container'>
  <div class="address_list">
   <div>
    <el-dialog v-bind:title="$t('addressRegistration')" :visible.sync="dialogVisible" class="modal">
     <el-form ref="addressForm" :rules="rules" :model="addressForm">
      <div class="fieldset">
       <div class="field">
        <div v-if="errorSubmitting" class="time_tip"><span>{{ $t('correctErrors') }}</span></div>
        <!--地址信息-->
        <div class="two">
         <div class="width">
          <el-form-item prop="FirstName">
           <el-input v-bind:placeholder="$t('firstName')" v-model="addressForm.FirstName"></el-input>
          </el-form-item>
         </div>
         <div class="width">
          <el-form-item prop="LastName">
           <el-input v-bind:placeholder="$t('lastName')" v-model="addressForm.LastName"></el-input>
          </el-form-item>
         </div>
        </div>
        <div>
         <el-form-item prop="Address">
          <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="addressForm.Address"></el-input>
         </el-form-item>
        </div>
         <div class="width">
          <el-form-item prop="Telephone">
           <el-input v-bind:placeholder="$t('phone')" v-model="addressForm.Telephone"></el-input>
          </el-form-item>
        </div>
        <div>
         <el-form-item prop="City">
          <el-input v-bind:placeholder="$t('city')" v-model="addressForm.City"></el-input>
         </el-form-item>
        </div>
        <div class="three">
         <div class="width_30">
          <div class="city">
           <el-form-item prop="Country">
            <el-select v-model="addressForm.Country" value="">
             <el-option v-for="item in CountryList" :key="item.value" :label="item.label" :value="item.value">
             </el-option>
            </el-select>
           </el-form-item>
          </div>
         </div>
         <div class="width_30">
          <div class="city">
           <el-form-item prop="State">
            <el-select v-model="addressForm.State" v-bind:placeholder="$t('pleaseSelect')" value="">
             <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
             </el-option>
            </el-select>
           </el-form-item>
          </div>
         </div>
         <div class="width_30">
          <div>
           <el-form-item prop="Zip">
            <el-input v-bind:placeholder="$t('zipCode')" v-model="addressForm.Zip"></el-input>
           </el-form-item>
          </div>
         </div>
        </div>
        <span class="dialog-footer" slot="footer">
         <button class="btnCancel" @click="handleClose($event)">{{ $t('cancel') }}</button>
         <button class="btn" :class="submitting? 'greybackground' : ''" @click="onSubmit($event, addressForm)">{{ $t('confirm') }}</button>
        </span>
       </div>
      </div>
     </el-form>
    </el-dialog>
   </div>
   <div>
    <div style="marginBottom: 1em" class="address-container" v-if="addresses.length > 0">
     <ul v-for="(address, index) in addresses">
      <li style="margin: 15px" class="address-key" :key="index">
        <span :style="'font-size: 18px; margin-bottom: 10px;'">{{address.FirstName + ' ' + address.LastName}} </span>
       <span class="addressDisplay">{{ address.Street }}</span>
       <span class="address-box-line">{{ address.City + ', ' + address.State}}</span>
       <span class="address-box-line">{{address.Zip}}</span>
       <span class="address-box-line">{{address.Country}}</span>
       <span class="address-box-line">{{address.Telephone}}</span>
       <div class="edit-delete-container">
        <span class="deleteBtn" @click="editAddressModalOpen(address)">Edit</span>
        <span class='editBtn' @click="openConfirmationDeleteAlert(address.CustomerDetail_id)">Delete</span>
       </div>
      </li>
     </ul>
      <div class="title" @click="newAddressAdd">
        <i class="el-icon-plus"></i><span>{{ $t('addNewAddress') }}</span>
      </div>
    </div>
   </div>
  </div>
 </div>
</div>
</template>

<script>
import {
 mapState,
 mapActions,
 mapMutations
} from 'vuex'
import {
 MessageBox
} from 'element-ui';
export default {
 name: 'account-address',
 data() {
  return {
   dialogVisible: false,
   errorSubmitting: false,
   submitting: false,
   addressForm: {
    FirstName: '', //名字
    LastName: '', //名字
    Address: '', //地址
    apartment: '', //地址
    City: '', //城市
    Zip: '', //编码
    Telephone: '', //联系方式
    Country: 'United States', //国家/地区
    State: 'CA', //地区
   },
   CountryList: [{
    value: '',
    label: '---'
   }, {
    value: 'United States',
    label: 'United States'
   }],
   stateOptions: this.$store.state.addresses.states,
  }
 },
  // computed: {
  computed: mapState({
    addresses: state => state.addresses.customerDetails,
    rules(){
      return {
        FirstName: [{
            required: true,
            message: this.$t('firstNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('firstNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        LastName: [{
            required: true,
            message: this.$t('lastNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('lastNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        Address: [{
            required: true,
            message: this.$t('addressRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 30,
            message: this.$t('addressNumberLengthRequired'),
            trigger: 'blur'
          }
          ],
        City: [{
            required: true,
            message: this.$t('cityRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: this.$t('cityLengthRequired'),
            trigger: 'blur'
          }
        ],
        Zip: [{
            required: true,
            message: this.$t('zipCodeRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 5,
            message: this.$t('zipCodeLengthRequired'),
            trigger: 'blur'
          }
        ],
        Telephone: [{
            required: false,
            message: this.$t('phoneNumberRequired'),
            trigger: 'blur'
          },
          {
            min: 10,
            max: 12,
            message: this.$t('phoneNumberLengthRequired'),
            trigger: 'blur',
          }
        ],
        Country: [{
            required: true,
            message: this.$t('countryRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: this.$t('countryLengthRequired'),
            trigger: 'blur'
          }
        ],
      }
    }
  }),
 methods: {
  ...mapActions('addresses', ['fetchAddresses', 'postAddress', 'deleteAddress', 'editAddress']),
  resetForm() {
   this.addressForm = {
    FirstName: '', //名字
    LastName: '', //名字
    Address: '', //地址
    apartment: '', //地址
    City: '', //城市
    Zip: '', //编码
    Telephone: '', //联系方式
    Country: 'United States', //国家/地区
    State: 'CA', //地区
   }
  },
  openAlert() {
   this.$alert('You have successfully added a new address', 'Success', {
    confirmButtonText: 'OK',
    type: 'success',
    center: true
   }).then(() => {
    this.dialogVisible = false;
   }).catch(() => {});
  },
  openEditSuccessAlert() {
   this.$alert('An address has been modified', 'Success', {
    confirmButtonText: 'OK',
    type: 'success',
    center: true
   }).then(() => {
     this.fetchAddresses();
    this.dialogVisible = false;
   }).catch(() => {});
  },
  openConfirmationDeleteAlert(id) {
   MessageBox.confirm('Remove this address from the list?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'CANCEL',
    type: 'warning',
    center: true
   }).then(() => {
    this.deleteAddress(id);
   }).catch(() => {});
  },
  handleClose(event) {
   event.preventDefault();
   this.dialogVisible = false;
  },
  onSubmit(event, form) {
   if (this.submitting) {
    return;
   }
   event.preventDefault();
   this.$refs['addressForm'].validate((valid) => {
    if (!valid) {
     return;
    } else {
      let address;
      if (!form.apartment || form.apartment === "undefined") {
        address = {
            ...form,
          Street: form.Address,
        };
      } else {
        address = {
         ...form,
         Street: form.Address + ',' + form.apartment,
        };
      }
     this.submitting = true
     if (address.CustomerDetail_id) {
      this.editAddress([address, address.CustomerDetail_id])
       .then(res => {
        this.openEditSuccessAlert();
        this.submitting = false;
       })
       .catch(err => {
        alerrt(err)
       })
     } else {
      this.postAddress(address)
       .then((res) => {
        this.openAlert();
        this.resetForm();
        this.submitting = false;
        this.$refs['addressForm'].clearValidate();
       })
       .catch(err => {
        alert(err);
       })
     }
    }
   });
  },
  editAddressModalOpen(address) {
   const newAddress = {
    ...address,
    Address: address.Street,
   }
   this.addressForm = newAddress;
   this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
   this.dialogVisible = true;
  },
  newAddressAdd() {
   this.resetForm();
   this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
   this.dialogVisible = true;
  }
 },
 mounted() {
  this.fetchAddresses();
 },
//  computed: mapState({
//   addresses: state => state.addresses.customerDetails
//  }),
}
</script>

<style lang="less">
// @import "../../assets/css/profile.less";
.address_container {
 // border: 3px solid red;
 padding: 5% 5%;

 @media only screen and (max-width: 1000px) {
  .el-message-box--center {
   width: 90% !important;
  }
 }

 .fieldset {
  padding: 33px 25px;

  .el-input__inner {
   background-color: white;
   color: #000;
   border: 1px solid black;
   border-radius: 5px;
   &:focus {
     border: 1px solid #E60000;
   }
  }

  input::-webkit-input-placeholder {
   color: #000000;
  }

  input::-ms-input-placeholder {
   color: #000000;
  }

  .two {
   .width {
    width: 49%;
   }

   .el-input__inner {
    width: 100%;
   }

   display: flex;
   justify-content: space-between;
  }

  .three {
   display: flex;
   justify-content: space-between;

   .width_30 {
    width: 31%;

    .el-input__suffix {
     border-left: 1px rgba(179, 179, 179, 0.5) solid;
     height: 95%;
    }

    .el-select {
     margin: 0;
     width: 100% !important;
    }
   }

   @media only screen and (max-width: 1000px) {
    display: inline-block;

    .width_30 {
     width: 100%;

     .el-select {
      margin: 0;
      width: 100% !important;
     }
    }
   }
  }

  .place {
   width: 100%;
   height: 40px;
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 0;
   margin-top: 50px;
  }

  .btn {
   cursor: pointer;
   // display: block;
   background-color: #E60000;
   background-clip: border-box;
   box-sizing: border-box;
   border: 1px transparent solid;
   border-radius: 5px;
   color: white;
   font-weight: 500;
   padding: 15px;
   text-align: center;
   position: relative;
   transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
   float: right;
  }

  .btnCancel {
   cursor: pointer;
   display: inline-block;
   background-color: transparent;
   background-clip: border-box;
   box-sizing: border-box;
   border: 1px transparent solid #E60000;
   border-radius: 5px;
   color: #E60000;
   font-weight: 500;
   padding: 15px;
   text-align: center;
   position: relative;
   font-size: 14px;
   transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }
 }

 .header_container {
  border-bottom: 1px solid silver;
  padding-bottom: 12px;
 }

 .address_body_container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1000px) {
   .address_list {
    .el-dialog {
     width: 90%
    }
   }
  }

  // border:
  .title {
   display: flex;
   width:40%;
   height: 200px;
   justify-content: center;
   align-items: center;
   margin: 5px;
   color: black;
   background: white;
   border: 1px solid rgba(151,151,153, .4);
   border-radius: 4px;
   cursor: pointer;

  //  width: 33%;
  //  border: 1px solid rgba(151,151,153, .4);
  //  border-radius: 4px;
  //  margin: 5px;
  //  font-weight: 500;
   span {
    font-weight: 400;
   }

   i {
    margin-right: 10px;
   }
  }
 }
 @media only screen and (max-width: 1000px)  {
   .address_body_container {
      .title {
      display: flex;
      width: 45%;
      height: 200px;
      justify-content: center;
      align-items: center;
      margin: 5px;
      color: black;
      background: white;
      border: 1px solid rgba(151,151,153, .4);
      border-radius: 4px;
      cursor: pointer;
        span {
          font-weight: 400;
        }
        i {
          margin-right: 10px;
        }
      }
    }
 }

  @media only screen and (max-width: 767px)  {
   .address_body_container {
      .title {
      display: flex;
      width: 80%;
      height: 200px;
      justify-content: center;
      align-items: center;
      margin: 5px;
      color: black;
      background: white;
      border: 1px solid rgba(151,151,153, .4);
      border-radius: 4px;
      cursor: pointer;
        span {
          font-weight: 400;
        }
        i {
          margin-right: 10px;
        }
      }
    }
 }

 .modal {
  margin-top: 100px;
 }

 .dialog-footer {
  display: block;
  // flex-direction: row;
  // height:30px;
  // .btn_submit {
  //   float: right;
  // }
 }

 button {
  outline: none;
 }

 .time_tip {
  color: #E60000;
  font-size: 12px;
  // margin-left: 10px;
 }

 .address-container {
  display: flex;
  flex-direction: row;
  background-color: white;
  padding: 1em;
  flex-wrap: wrap;
  border-radius: 0.2em;
  // border: 1px solid black;
  border-top: none;

  @media only screen and (max-width: 1000px) {
   .addressDisplay {
    display: block;
   }
   ul {
     width: 45%;
   }
  }

    @media only screen and (max-width: 600px){
    ul  {
      width: 80%;
    }
  }

  .next-line {
   white-space: initial;
   display: inline-flex;
  }
 }

 ul {
   width: 40%;
   border: 1px solid rgba(151,151,153, .4);
   border-radius: 4px;
   margin: 5px;
   font-weight: 500;
  li {
    // width: 30%;
    display: flex;
    flex-direction: column;
    line-height: 21px;
    // border: 1px solid black;
    // border-radius: 7px;
   .deleteBtn {
    color: #E60000;
    margin: 5px;
    font-size: 12px;
    font-weight: 400;
    &:hover {
      cursor: pointer;
    }
   }

   .editBtn {
     color: #E60000;
     margin: 5px;
     font-size: 12px;
     font-weight: 400;
    &:hover {
      cursor:pointer;
    }
   }

   i {
    font-size: 20px;
    padding: 5px;
    cursor: pointer;
   }

   i:hover {
    color: #f5a623;
    // background: #f5a623;
    // background-color: red;
   }

  }
 }

 .greybackground {
  background-color: grey !important;
 }
}
.address-box-line {
  font-size: 12px;
}
.edit-delete-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.el-message-box__status.el-icon-warning {
  color: black;
}
.el-message-box__message {
  color: black;
}
// .el-button  {
//   background-color: #E60000;
//   color: white;
//   &:hover {
//     background-color: #FB6E72;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/view/Profile/address.vue